import {Box, createStyles} from '@mantine/core';
import React from 'react';

import PlateDesignTemplateSelector from 'samples/plate-maps/scratch-plates/PlateDesignTemplateSelector';

interface PlateDesignTemplateSearchEditorProps {
  value: string | null;
  onChange: (templateId: string | null) => void;
  disabled?: boolean;
}

const useStyles = createStyles({
  fullWidth: {
    width: '100%',
    '& .selectDropdown': {
      width: '100%',
    },
    '& .selectDropdown-button': {
      width: '100%',
    },
  },
});

export default function PlateDesignTemplateSearchEditor({
  value,
  onChange,
  disabled,
}: PlateDesignTemplateSearchEditorProps): JSX.Element {
  const {classes} = useStyles();
  const handleSelectTemplate = (templateId: string): void => {
    onChange(templateId);
  };
  const handleClearTemplate = (): void => {
    onChange(null);
  };

  return (
    <Box className={classes.fullWidth}>
      <PlateDesignTemplateSelector
        disabled={disabled}
        selectedTemplateId={value}
        onSelectTemplate={handleSelectTemplate}
        onClearTemplate={handleClearTemplate}
      />
    </Box>
  );
}
